import './Loading.css';

export default function Loading() {
  const newLocal = "lds-roller";
  return <div className="loaderContainer">
    <div className="rotateLoader"></div>
     {/* <div className={newLocal}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div> */}
     </div>
  }


  /* HTML:  */
